import React from 'react';
import { AUTORIZACAO, CAS, DESCRIPTION_RESTRICTIONS, EC, ENTRYNO, RESTRICOES, SVHC } from 'utils/echa/constants';

const cellEmptyElements = field => {
  if (field) {
    if (Array.isArray(field) && typeof field[0] === 'string') {
      return (
        <div>
          {
            field.map((value, index) => value === '' ?
              <div key={index}>-</div> :
              <div key={index}>{value}</div>
            )}
        </div>
      );
    } else if (typeof field === 'string' && field === '') {
      return '-';
    }
    return field;
  }
  return '-';
};

const cellMultipleElements = field => {
  if (field && field.length > 0) {
    return (
      <div>
        {
          field.map((val, index) =>
            index % 2 === 0 ?
              <div key={index}>{val === '' ? '-' : val}</div> :
              <div key={index} style={{ backgroundColor: 'lightGrey' }}>{val === '' ? '-' : val}</div>
          )
        }
      </div>
    );
  }
  return '-';
};

/**
 * imported lables directly from raw CSV files
 */
// title and field properties are used in material table,
// label and key are used in CSV export
export const importEchaTableColumns = [
  { title: 'Nome', field: 'Name', label: 'Nome', key: 'Name' },
  {
    title: 'EC', field: EC, label: 'EC', key: EC,
    render: rowData => cellEmptyElements(rowData[EC])
  },
  {
    title: 'CAS', field: CAS, label: 'CAS', key: CAS,
    render: rowData => cellEmptyElements(rowData[CAS])
  },
  {
    title: 'SVHC descr.', field: 'DescriptionSvhc', colRename: 'Description', label: 'SVHC descr.', key: 'DescriptionSvhc',
    render: rowData => cellEmptyElements(rowData['DescriptionSvhc'])
  },
  {
    title: 'SVHC inclusão', field: 'Reason for inclusion', label: 'SVHC inclusão', key: 'Reason for inclusion',
    render: rowData => cellEmptyElements(rowData['Reason for inclusion'])
  },
  {
    title: 'SVHC data', field: 'Date of inclusion', label: 'SVHC data', key: 'Date of inclusion',
    render: rowData => cellEmptyElements(rowData['Date of inclusion'])
  },
  {
    title: 'Restrições descr.',
    field: DESCRIPTION_RESTRICTIONS,
    render: rowData => cellMultipleElements(rowData[DESCRIPTION_RESTRICTIONS]),
    label: 'Restrições descr.',
    key: DESCRIPTION_RESTRICTIONS
  },
  {
    title: 'Restrições entrada',
    field: ENTRYNO,
    render: rowData => cellMultipleElements(rowData[ENTRYNO]),
    label: 'Restrições entrada',
    key: ENTRYNO
  },
  {
    title: 'Autorização data', field: 'Sunset Date', label: 'Autorização data', key: 'Latest application date',
    render: rowData => cellEmptyElements(rowData['Sunset Date'])
  },
  {
    title: 'Autorização isenções', field: 'Exempted (categories of) uses', label: 'Autorização isenções', key: 'Exempted (categories of) uses',
    render: rowData => cellEmptyElements(rowData['Exempted (categories of) uses'])
  }
];

/**
 * Echa columns as an internal structure not like importEchaTableColumns
 *  which are still with raw types from files
 */
// title and field properties are used in material table,
// label and key are used in CSV export
export const echaTableColumns = [
  { title: 'Nome', field: 'name', label: 'Nome', key: 'name' },
  {
    title: 'CAS', field: 'cas', label: 'CAS', key: 'cas',
    render: rowData => cellEmptyElements(rowData['cas'])
  },
  {
    title: 'EC', field: 'ec', label: 'EC', key: 'ec',
    render: rowData => cellEmptyElements(rowData['ec'])
  },
  {
    title: 'SVHC descr.', field: 'svhc_description', label: 'SVHC descrição', key: 'svhc_description',
    render: rowData => cellEmptyElements(rowData['svhc_description'])
  },
  {
    title: 'SVHC inclusão', field: 'svhc_inclusion_reasons', label: 'SVHC inclusão', key: 'svhc_inclusion_reasons',
    render: rowData => cellEmptyElements(rowData['svhc_inclusion_reasons'])
  },
  {
    title: 'SVHC data', field: 'svhc_inclusion_date', label: 'SVHC data inclusão', key: 'svhc_inclusion_date',
    render: rowData => cellEmptyElements(rowData['svhc_inclusion_date'])
  },
  {
    title: 'Restrições descr.', field: 'restriction_descriptions', label: 'Restrições descrição', key: 'restriction_descriptions',
    render: rowData => cellMultipleElements(rowData['restriction_descriptions'])
  },
  {
    title: 'Restrições entrada', field: 'restriction_entry_numbers', label: 'Restrições entrada', key: 'restriction_entry_numbers',
    render: rowData => cellMultipleElements(rowData['restriction_entry_numbers'])
  },
  {
    title: 'Autorização data', field: 'authorization_dates', label: 'Autorização data limite', key: 'authorization_dates',
    render: rowData => cellEmptyElements(rowData['authorization_dates'])
  },
  { title: 'Autorização isenções', field: 'authorization_exempted_uses', label: 'Autorização isenções', key: 'authorization_exempted_uses',
    render: rowData => cellEmptyElements(rowData['authorization_exempted_uses'])
  }
];

export const commonCols = [
  { title: 'Nome', field: 'Name', init: 'string' },
  { title: 'EC', field: EC, init: 'array' },
  { title: 'CAS', field: CAS, init: 'array' }
];

export const svhcCols = [
  { title: 'SVHC descr.', field: 'DescriptionSvhc', colRename: 'Description', init: 'string' },
  { title: 'SVHC inclusão', field: 'Reason for inclusion', init: 'string' },
  { title: 'SVHC data', field: 'Date of inclusion', init: 'string' }
];

export const restricoesCols = [
  { title: 'Restrições descr.', field: DESCRIPTION_RESTRICTIONS, colRename: 'Description', init: 'array' },
  { title: 'Restrições entrada', field: ENTRYNO, init: 'array' }
];

export const autorizacaoCols = [
  { title: 'Autorização data', field: 'Sunset Date', init: 'string' },
  { title: 'Autorização isenções', field: 'Exempted (categories of) uses', init: 'string' }
];

export const echaColumns = [...commonCols, ...svhcCols, ...restricoesCols, ...autorizacaoCols];

/**
 * What each file has to bring, in the file's own words.
 *
 * Only the columns we read. The agency publishes eleven per file and we import
 * ten across the three; the other thirteen are theirs to rename, drop or add
 * without it being any of our business. Requiring them was the reverse of
 * useful: a `Review Periods` we never look at could refuse an entire upload,
 * while a missing `Sunset Date` sailed through, because sanitize invents the
 * columns it knows about before the validator sees them - so the ones that
 * matter were the ones that could not be checked.
 *
 * Checked here, against the raw file, before any of that runs. Same shape as
 * checkColumns in utils/import/columns.js, and for the same reason: every
 * check after this one reads a column by name.
 *
 * ⚠️ These are the file's headers, not our field names, and not always what
 * ends up in the payload. sanitize renames `Description` per file, because all
 * three use that word for different things, and on the authorisation file it
 * also moves `Entry no.` aside - which is why `Entry no.` is required of the
 * restrictions file and not of that one.
 */
export const requiredHeaders = {
  [SVHC]: ['Name', EC, CAS, 'Description', 'Reason for inclusion', 'Date of inclusion'],
  [RESTRICOES]: ['Name', EC, CAS, 'Description', ENTRYNO],
  [AUTORIZACAO]: ['Name', EC, CAS, 'Sunset Date', 'Exempted (categories of) uses']
};

/**
 * Phase one: does the file have the columns we are about to read?
 *
 * Extra columns are fine and unmentioned - that is the point. Returns [] when
 * the file is usable, so the caller can carry on.
 */
export const checkEchaColumns = (rows, type) => {
  const expected = requiredHeaders[type] || [];
  const present = rows.length === 0 ? [] : Object.keys(rows[0]);
  const missing = expected.filter(column => !present.includes(column));

  if (rows.length === 0) {
    return [{ fileType: type, column: '-', message: 'O ficheiro não tem linhas.' }];
  }

  return missing.map(column => ({
    fileType: type,
    column,
    message: `Falta a coluna "${column}". O ficheiro tem de ter, pelo menos: ${expected.join(', ')}.`
  }));
};

/**
 * The file's header on the left, the API's field on the right.
 *
 * The same shape and the same name as the map in utils/import/columns.js, which
 * is the point: three files arrive here from outside, all three need the same
 * question answered - what is this column called on our side - and it should
 * read the same way in every one of them.
 *
 * It used to be written the other way round, our field pointing at the header.
 * Both directions work; having two is what does not. Reading the ECHA import
 * after the customer ones meant re-learning which side was which, every time.
 *
 * ⚠️ These are post-sanitize headers. All three files call something
 * `Description`, so sanitize renames it per file before anything reads it.
 */
export const translateFileHeadersToApiFields = {
  'Name': 'name',
  [EC]: 'ec',
  [CAS]: 'cas',
  'DescriptionSvhc': 'svhc_description',
  'Reason for inclusion': 'svhc_inclusion_reasons',
  'Date of inclusion': 'svhc_inclusion_date',
  [DESCRIPTION_RESTRICTIONS]: 'restriction_descriptions',
  [ENTRYNO]: 'restriction_entry_numbers',
  'Sunset Date': 'authorization_dates',
  'Exempted (categories of) uses': 'authorization_exempted_uses'
};

/**
 * The file's names become the API's, on the way out - and arrays become the
 * strings the column stores.
 *
 * ⚠️ A header the file does not carry becomes an empty string rather than being
 * left out. That is why every row of `echa` is non-null and never NULL, and why
 * a column missing from the map stays empty for years without anyone noticing:
 * the row still arrives, just hollow. checkEchaColumns is what now refuses the
 * file instead.
 */
export const echaTransformForImport = echa => {
  const echaTransformed = {};
  Object.entries(translateFileHeadersToApiFields).forEach(([header, field]) => {
    const value = echa[header];
    if (value) {
      echaTransformed[field] = Array.isArray(value) ? JSON.stringify(value) : value;
    } else {
      echaTransformed[field] = '';
    }
  });
  return echaTransformed;
};

export default {
  importEchaTableColumns,
  echaTableColumns,
  autorizacaoCols,
  echaColumns,
  commonCols,
  restricoesCols,
  svhcCols,
  echaTransformForImport
};
